export const TEMP_AREA_ID = "TEMP_AREA";
export const OPTION_ALL_FLOOR = "ALL_FLOOR";
export const OPTION_NO_AREA = "NO_AREA";
export const OPTION_ALL_AREA = "ALL_AREA";
